import matchSorter from 'match-sorter';
import { documentType } from 'pages/CarsQuotation/resources';
import { cities } from 'pages/CarsQuotation/cities';

/** Config del lote. El backend rechaza > 25. */
export const MAX_ROWS = 25;

/** Cada cuánto se consulta el estado del lote (ms). */
export const POLL_INTERVAL_MS = 12000;

/** Tope de reloj: si a esto el lote sigue PROCESSING, se corta el polling (ms). */
export const POLL_MAX_MS = 25 * 60 * 1000;

/** v1: solo Auto. */
export const QUOTE_TYPE = 'Auto';

export const genderOptions = [
  { value: 'm', label: 'Masculino' },
  { value: 'f', label: 'Femenino' },
];

export const onerosoOptions = [
  { value: 'si', label: 'Sí' },
  { value: 'no', label: 'No' },
];

export { documentType, cities };

/** Fila vacía para "Agregar fila". */
export const emptyRow = (): IBulkQuoteRow => ({
  firstName: '',
  lastName: '',
  documentType: 'cc',
  nDocument: '',
  gender: 'm',
  fBorn: '',
  licenseVehicle: '',
  city: null,
});

/** Opciones de ciudad filtradas por texto (para el async select). */
export const loadCityOptions = (
  input: string,
  cb: (opts: { value: string; label: string }[]) => void
) => {
  const list = input
    ? matchSorter(cities, input, { keys: ['label', 'value'] }).slice(0, 50)
    : cities.slice(0, 50);
  cb(list);
};
